import React from 'react';
import PropTypes from 'prop-types';
import theme from './style.css';

// note that grid is now generic and doesn't care about what is passed into it
const Grid = (props = {}) => {
  const { children, gridType } = props;
  if (!gridType) return null;
  return (
    <div className={theme[gridType]}>
      <div className={theme.grid}>{children}</div>
    </div>
  );
};

Grid.defaultProps = {
  children: null,
};
Grid.propTypes = {
  children: PropTypes.element,
  gridType: PropTypes.oneOf([
    'grid-2-1',
    'grid-3-1',
    'grid-3-2',
    'grid-4-1',
    'grid-4-2',
    'grid-4-2-1',
    'grid-4-3',
    'grid-4-3-1',
    'grid-5-4-2-1',
    'grid-5-4-3-1',
    'grid-horizontal-3',
  ]).isRequired,
};

export default Grid;
